import {
    EG_GET_PLANNED_DATE_REQUEST, EG_GET_PLANNED_DATE, GET_EQUIPMENT_GROUP_LIST, SET_SELECTED_EQUIPMENT_GROUP, SET_SELECTED_EG, GET_CREW_EQUIPMENT_GROUP_LIST,
    EQUIPMENT_GROUP_SUCCESS, EQUIPMENT_GROUP_FAILURE, EQUIPMENT_GROUP_FORM_CLEAR, LOAD_HISTORY, SET_AUTOMATIC_LOAD_COUNT,
    CLEAR_EQUIPMENT_GROUP_LIST, GET_HARVESTER_LIST, GET_LOAD_HISTORY_REQUEST, GET_EQUIPMENT_GROUP_LIST_REQUEST,
    GET_GEO_SHAPE_LIST, EG_GET_REGION_LIST_REQUEST, EG_GET_REGION_LIST, EG_GET_WORKED_ACRES_REQUEST, EG_GET_WORKED_ACRES,
    SET_BULK_LOAD, EDIT_BULK_LOAD, REMOVE_BULK_LOAD, CLEAR_BULK_LOAD, EDIT_BULK_LOADS, SET_ROUNDTRIP_DETAIL, SET_ROUNDTRIP_REQUEST, DELETED_LOAD_HISTORY_REQUEST, DELETED_LOAD_HISTORY, SET_DELETED_LOAD, SET_RESTORE_LOAD, EG_REPORT_ISSUE, EG_REPORT_ISSUE_REQUEST, SET_EG_REGION_LOCATION_REQUEST, SET_EG_REGION_LOCATION, LOAD_HISTORY_HEADER, SET_EG_REGION_LOCATION_LOG, SET_EG_REGION_LOCATION_LOG_REQUEST, GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST, GET_ALL_EQUIPMENT_GROUP_LIST
} from '../constants/action-types';
import { getAreaOfPolygon } from 'geolib';
import { Unit } from '../helpers/unit';
import { getWorkedAcres } from '../interceptors/dashboard';
import { uuid } from '../helpers/common';
import produce from 'immer';

const initialState = {
    isRequesting: false,
    equipmentGroupList: [],
    selectedEquipmentGroup: '',
    selectedEGlist: [],
    plannedDate: {},
    crewEquipmentGroups: {
        isFetching: false,
        list: []
    },
    save: {
        isSuccess: true,
        message: ''
    },
    fieldListById: {
        isRequesting: false,
        isRequestingWorkedAcres: false,
        payload: {},
        regionList: {}
    },
    loadHistory: {
        isRequesting: false,
        automaticLoadCount: 0,
        load: {
            total_capacity: 0,
            total_count: 0,
            total_load_seconds: 0
        },
        history: [],
        isRequestingDeletedLoads: false,
        deletedHistory: [],
        newLoadIds: [],
        bulkEditLoadList: []
    },
    harvesterList: [],
    geoShapeList: [],
    roundTripList: [],
    EGReportIssue: {
        isRequesting: false,
        list: null
    },
    EGRegionLocation: {
        payload: {},
        isRequesting: false
    },
    loadHistroyHeader: [],
    EGRegionLocationLog: {
        payload: {},
        isRequesting: false
    },
    allEG: {
        isRequesting: false,
        list: []
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case EG_GET_PLANNED_DATE_REQUEST: {
            // if (!action.id) return;
            state = {
                ...state,
                plannedDate: {
                    ...state.plannedDate,
                    [action.id]: {
                        isRequesting: true,
                        payload: {
                            fromDate: null,
                            toDate: null
                        }
                    }
                }
            };
            break;
        }
        case EG_GET_PLANNED_DATE: {
            const { id, payload } = action;
            if (id)
                state = {
                    ...state,
                    plannedDate: {
                        ...state.plannedDate,
                        [id]: {
                            ...state.plannedDate[id],
                            isRequesting: false,
                            ...payload && {
                                payload: {
                                    fromDate: payload.start_date,
                                    toDate: payload.end_date
                                }
                            }
                        }
                    }
                };
            break;
        }
        case GET_EQUIPMENT_GROUP_LIST_REQUEST:
            state = { ...state, isRequesting: true, equipmentGroupList: initialState.equipmentGroupList };
            break;
        case GET_EQUIPMENT_GROUP_LIST:
            state = { ...state, isRequesting: false, equipmentGroupList: action.payload };
            break;
        case SET_SELECTED_EG:
            state = { ...state, selectedEGlist: action.payload };
            break;
        case SET_SELECTED_EQUIPMENT_GROUP:
            state = { ...state, selectedEquipmentGroup: action.payload };
            break;
        case GET_CREW_EQUIPMENT_GROUP_LIST: {
            const pState = {
                ...initialState.crewEquipmentGroups,
                ...action.payload,
                isFetching: (action.isFetching === true),
                list: action.payload ? action.payload : initialState.crewEquipmentGroups.list
            }
            state = { ...state, crewEquipmentGroups: pState };
            break;
        }
        case EQUIPMENT_GROUP_SUCCESS:
            state = { ...state, save: initialState.save };
            break;
        case EQUIPMENT_GROUP_FAILURE:
            state = { ...state, save: { isSuccess: false, message: action.payload.message } };
            break;
        case EQUIPMENT_GROUP_FORM_CLEAR:
            state = { ...state, save: initialState.save };
            break;
        case CLEAR_EQUIPMENT_GROUP_LIST:
            state = { ...state, equipmentGroupList: initialState.equipmentGroupList, selectedEGlist: [] };
            break;
        case GET_LOAD_HISTORY_REQUEST:
            state = {
                ...state,
                loadHistory: {
                    ...initialState.loadHistory,
                    newLoadIds: [],
                    isRequesting: true
                }
            };
            break;
        case LOAD_HISTORY:
            const history = action.payload && action.payload.history ? action.payload.history : null;
            const load = action.payload && action.payload.load ? action.payload.load : null;
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    isRequesting: false,
                    ...history && { history },
                    ...load && { load }
                }
            };
            break;
        case SET_DELETED_LOAD: {
            const { loadActivityId } = action;
            if (!loadActivityId) return;
            const loadList = [...state.loadHistory.history];
            const deletedLoadList = [...state.loadHistory.deletedHistory];
            const deletedLoadIndex = loadList.map(item => item.load_activity_uuid).indexOf(loadActivityId);
            const deletedLoad = loadList[deletedLoadIndex];
            deletedLoad['restored_date'] = null;
            deletedLoadList.push(deletedLoad);
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    deletedHistory: deletedLoadList,
                }
            };

            break;
        }
        case SET_RESTORE_LOAD: {
            const { loadActivityId, restoredDate } = action;
            if (!loadActivityId) return;
            const loadList = [...state.loadHistory.history];
            const deletedLoadList = [...state.loadHistory.deletedHistory];
            const restoredLoadIndex = deletedLoadList.map(item => item.load_activity_uuid).indexOf(loadActivityId);
            let restoredLoad = deletedLoadList[restoredLoadIndex];
            restoredLoad['restored_date'] = restoredDate;
            loadList.push(restoredLoad);
            deletedLoadList.splice(restoredLoadIndex, 1);
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    history: loadList,
                    deletedHistory: deletedLoadList
                }
            };

            break;
        }
        case DELETED_LOAD_HISTORY_REQUEST: {
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    deletedHistory: [],
                    isRequestingDeletedLoads: true
                }
            };
            break;
        }
        case DELETED_LOAD_HISTORY: {
            const deletedHistory = action.payload && action.payload.history ? action.payload.history : [];
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    isRequestingDeletedLoads: false,
                    deletedHistory: [...deletedHistory]
                }
            };
            break;
        }
        case SET_AUTOMATIC_LOAD_COUNT: {
            const payload = action.payload ? action.payload : {};

            const loadDetail = Object.keys(payload).map(id => payload[id])[0];

            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    automaticLoadCount: loadDetail ? loadDetail.load_count : 0
                }
            };
            break;
        }
        case EG_GET_REGION_LIST_REQUEST: {
            state = {
                ...state,
                fieldListById: {
                    ...state.fieldListById,
                    isRequesting: true,
                    payload: {}
                }
            };
            break;
        }
        case EG_GET_REGION_LIST: {
            const { payload } = action;
            const unit = Unit.getInstance();

            const fieldListById = {};
            if (payload) payload.forEach(item => {
                item.shapes && item.shapes.forEach(e => {
                    const setOfLocation = (e.geo_shape_type === "polygon" && e.location) ? e.location.map(points => [points.lng, points.lat]) : [];
                    const totalArea = unit.toArea(getAreaOfPolygon(setOfLocation) * 0.000247105, 2);
                    fieldListById[e.geo_shape_uuid] = {
                        geo_region_uuid: item.geo_region_uuid,
                        geo_region_name: item.geo_region_name,
                        geo_region_type_id: item.geo_region_type_id,
                        geo_shape_uuid: e.geo_shape_uuid,
                        geo_shape_name: e.geo_shape_name,
                        totalArea,
                        workedArea: 0
                    }
                });
            });

            state = {
                ...state,
                fieldListById: {
                    ...state.fieldListById,
                    isRequesting: false,
                    payload: { ...fieldListById },
                    regionList: { ...payload }
                }
            };
            break;
        }
        case EG_GET_WORKED_ACRES_REQUEST: {
            state = {
                ...state,
                fieldListById: {
                    ...state.fieldListById,
                    isRequestingWorkedAcres: true
                }
            };
            break;
        }
        case EG_GET_WORKED_ACRES: {
            const { payload, range } = action;
            let fieldListById = state.fieldListById.payload;

            payload && payload.data && Array.isArray(payload.data) &&
                payload.data.filter(item => item.work_type_id === 2).forEach(item => {
                    const filteredIds = Object.keys(fieldListById).filter(id => fieldListById[id].geo_region_uuid === item.geo_region_uuid);
                    const { workedAcres } = getWorkedAcres(item, range);

                    for (const shapeId of filteredIds) fieldListById[shapeId] = { ...fieldListById[shapeId], workedArea: workedAcres };
                })

            state = {
                ...state,
                fieldListById: {
                    ...state.fieldListById,
                    isRequestingWorkedAcres: false,
                    payload: { ...fieldListById }
                }
            };
            break;
        }
        case GET_HARVESTER_LIST:
            state = { ...state, harvesterList: action.payload ? action.payload : initialState.harvesterList };
            break;
        case GET_GEO_SHAPE_LIST:
            state = { ...state, geoShapeList: action.payload ? action.payload : initialState.geoShapeList };
            break;
        case SET_BULK_LOAD: {
            const { loadActivityId } = action;
            if (!loadActivityId) return;
            const loadList = [...state.loadHistory.history];
            const newLoadIds = state.loadHistory.newLoadIds;

            const cloneIndex = loadList.map(item => item.load_activity_uuid).indexOf(loadActivityId);
            const cloneLoad = loadList[cloneIndex];

            let refLoadActivityId = newLoadIds.indexOf(loadActivityId) < 0
                ? loadActivityId : cloneLoad.parent_load_activity_uuid;

            const newLoad = {
                ...cloneLoad,
                load_activity_uuid: uuid(),
                approved: 0,
                modified_by_name_from_queue: null,
                approved_by_name: null,
                parent_load_activity_uuid: refLoadActivityId,
                restored_date: null
            };

            loadList.splice(cloneIndex + 1, 0, newLoad);
            newLoadIds.push(newLoad.load_activity_uuid);

            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    history: loadList,
                    newLoadIds
                }
            };

            break;
        }
        case EDIT_BULK_LOAD: {
            const { loadActivityId, payload } = action;
            if (!loadActivityId || !payload) return;

            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    history: [...state.loadHistory.history].map(item => {
                        if (item.load_activity_uuid === loadActivityId) return { ...item, ...payload }
                        else return item;
                    })
                }
            };
            break;
        }
        case EDIT_BULK_LOADS: {
            const { payload } = action;
            if (!Array.isArray(payload)) return;

            state = produce(state, s => {
                const newHistory = s.loadHistory.history.map(item => {
                    const load = payload.find(e => e.load_activity_uuid === item.load_activity_uuid);
                    if (load) return { ...item, ...load };
                    return item;
                });
                s.loadHistory.history = newHistory;
            });
            break;
        }
        case SET_ROUNDTRIP_REQUEST: {
            state = { ...state, roundTripList: [], isRequesting: true }
            break;
        }
        case SET_ROUNDTRIP_DETAIL: {
            let roundTripList = action.payload;
            state = { ...state, roundTripList, isRequesting: false }
            break;
        }
        case REMOVE_BULK_LOAD: {
            let loadActivityIds = action.payload
                ? Array.isArray(action.payload) ? action.payload : [action.payload]
                : state.loadHistory.newLoadIds;

            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    history: [...state.loadHistory.history].filter(item =>
                        (loadActivityIds.indexOf(item.load_activity_uuid) < 0)),
                    newLoadIds: state.loadHistory.newLoadIds.filter(loadActivityId =>
                        (loadActivityIds.indexOf(loadActivityId) < 0))
                }
            }
            break;
        }
        case CLEAR_BULK_LOAD: {
            state = {
                ...state,
                loadHistory: {
                    ...state.loadHistory,
                    newLoadIds: []
                }
            }
            break;
        }
        case EG_REPORT_ISSUE_REQUEST: {
            state = {
                ...state, EGReportIssue: {
                    ...state.EGReportIssue,
                    list: null,
                    isRequesting: true
                }
            }
            break;
        }
        case EG_REPORT_ISSUE: {
            let reportIssue = action.payload;
            state = {
                ...state, EGReportIssue: {
                    ...state.EGReportIssue,
                    list: reportIssue,
                    isRequesting: false
                }
            }
            break;
        }
        case SET_EG_REGION_LOCATION_REQUEST: {
            state = {
                ...state, EGRegionLocation: {
                    ...state.EGRegionLocation,
                    isRequesting: true,
                }
            }
            break;
        }
        case SET_EG_REGION_LOCATION: {
            state = {
                ...state, EGRegionLocation: {
                    ...state.EGRegionLocation,
                    ...action.payload && {
                        payload: {
                            ...state.EGRegionLocation.payload,
                            ...action.payload
                        }
                    },
                    isRequesting: false
                }
            }
            break;
        }
        case LOAD_HISTORY_HEADER: {
            state = {
                ...state,
                loadHistroyHeader: action.payload
            }
            break;
        }
        case SET_EG_REGION_LOCATION_LOG_REQUEST: {
            state = {
                ...state, EGRegionLocationLog: {
                    ...state.EGRegionLocationLog,
                    isRequesting: true,
                }
            }
            break;
        }
        case SET_EG_REGION_LOCATION_LOG: {
            state = {
                ...state, EGRegionLocationLog: {
                    ...state.EGRegionLocationLog,
                    ...action.payload && {
                        payload: {
                            ...state.EGRegionLocationLog.payload,
                            ...action.payload
                        }
                    },
                    isRequesting: false
                }
            }
            break;
        }
        case GET_ALL_EQUIPMENT_GROUP_LIST_REQUEST: {
            state = { ...state, allEG: { isRequesting: true, list: [] } };
            break;
        }
        case GET_ALL_EQUIPMENT_GROUP_LIST: {
            state = { ...state, allEG: { isRequesting: false, list: action.payload } };
            break;
        }
        default:
            break;
    }
    return state;
}